import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../../createApiConfig';

export const lmIptvApi = createApi({
  reducerPath: 'lmIptvApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IPTV '],
  endpoints: builder => ({
    getIptvData: builder.query({
      query: (params) => ({
        url: `/links/iptv/`,
        params,
      }),
      providesTags: ['IPTV '],
    }),

    createIptvRecord: builder.mutation({
      query: (data) => ({
        url: '/links/iptv/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IPTV '],
    }),
    updateIptv: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/iptv/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['IPTV'],
    }),
    getIptvById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/iptv/${id}/`,
        params,
      }),
      providesTags: ['IPTV']
    }),
  }),
});

export const {
  useGetIptvDataQuery,
  useLazyGetIptvDataQuery,
  useCreateIptvRecordMutation,
  useUpdateIptvMutation,
  useGetIptvByIdQuery
} = lmIptvApi;
